import { InjectionToken } from '@angular/core';
import { CmsModuleConfig } from '@domgen/dgx-fe-content-management';

export const cmsConfigToken = new InjectionToken<CmsModuleConfig>(
  'CMS Config Per Deployment Environment'
);
